import Vue from 'vue'
import VueRouter from 'vue-router'

import TF50 from '@/pages/tf50'
import Garden from '@/pages/garden'
import Regent from '@/pages/regent'

Vue.use(VueRouter)

export default new VueRouter({
  routes: [
    {
      path: '/50th/:id',
      name: '50th',
      component: TF50
    },
    {
      path: '/garden/:id',
      name: 'garden',
      component: Garden
    },
    {
      path: '/regent',
      name: 'regent',
      component: Regent
    }
  ]
})
